import { useQuery } from '@apollo/client';
import { GET_QUESTIONNAIRE_OVERVIEW } from 'graphql/secure/queries/questionnaire.queries';
import React, { FC } from 'react';
import { useParams } from 'react-router-dom';
import { IBaseQuestionnaire } from 'FeatureModules/Questionnaire/types/questionnaire.types';

/**
 * Returns the title of the questionnaire, that is fetched from the cache only
 */
const QuestionnaireTitle: FC = () => {
  const { questionnaireId } = useParams();
  const { data, loading } = useQuery<{
    questionnaire: IBaseQuestionnaire;
  }>(GET_QUESTIONNAIRE_OVERVIEW, {
    variables: { id: questionnaireId },
    skip: !questionnaireId,
  });

  if (loading || !data?.questionnaire) {
    return <span>Loading...</span>;
  }

  return <span>{data.questionnaire.title}</span>;
};

export default QuestionnaireTitle;
